/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ users: NonNullable<unknown>, perUser: NonNullable<unknown> }} Plan_Tab_Storage_DetailInputs */



/**
* | output |
* | --- |
* | "{users} users × {perUser}" |
*
* @param {Plan_Tab_Storage_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_storage_detail = /** @type {((inputs: Plan_Tab_Storage_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Storage_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.users} Nutzer × ${i?.perUser}`)
	return /** @type {LocalizedString} */ (`${i?.users} users × ${i?.perUser}`)
});